import React from 'react';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../../contextsProperty/ContextProperties';
import LoadingPlaceholder from '../../../../../../muiComponents/LoadingPlaceholder';
import Title from '../../../Title';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Button from '../../../../../../muiComponents/Button';
import Menu from '../../../../components/Menu';
import routes from '../../../../../../utils/commonVariables/routes';
import encodeBase64 from '../../../../../../utils/encodeBase64';
import Card from '../../../../../../muiComponents/Card';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { stopSalesColumns } from '../../../../../../utils/property/propertyUtils';
import { commonIcons } from '../../../../../../utils/commonVariables/commonIcons';
import PropertyStopSalesRow from './PropertyStopSalesRow';

const PropertyStopSalesList = () => {
    const { isFetching } = usePropertyFetching();
    const { stopSales } = usePropertyPresentation();
    const translate = useTranslate();

    const getRouteToStopSalePanel = (id?: string) =>
        `${routes.landingPrivate}${routes.stopSales}${
            id ? `?id=${encodeBase64(id)}` : ''
        }`;

    const menuItems = [
        {
            text: 'create_new_stop_sale',
            icon: 'Add',
            onClick: () => {
                const route = getRouteToStopSalePanel('new');
                window.open(route, route);
            },
        },
        {
            text: 'manage_all_stop_sales',
            icon: commonIcons.STOP_SALE,
            onClick: () => {
                const route = getRouteToStopSalePanel();
                window.open(route, route);
            },
        },
    ];
    return (
        <section className='flex-column gap-10' id='stop_sales'>
            <div className='flex flex-between'>
                {isFetching ? (
                    <LoadingPlaceholder
                        variant='text'
                        height={24}
                        width='100%'
                    />
                ) : (
                    <div className='width100perc flex flex-between flex-align-baseline'>
                        <Title text='stop_sales' />
                        <Menu menuItems={menuItems} />
                    </div>
                )}
            </div>
            <Card className='padding-inline-20 overflow-x-auto'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {stopSalesColumns.map(column => (
                                <TableCell
                                    key={column.id}
                                    className='text-capitalize'
                                >
                                    {translate(column.label)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!stopSales.length ? (
                            <TableRow>
                                <TableCell colSpan={stopSalesColumns.length}>
                                    <div className='flex-center'>
                                        <Button
                                            startIcon='Add'
                                            variant='text'
                                            onClick={() => {
                                                const route =
                                                    getRouteToStopSalePanel(
                                                        'new'
                                                    );
                                                window.open(route, route);
                                            }}
                                        >
                                            {translate('create_new_stop_sale')}
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ) : (
                            stopSales.map(stopSale => (
                                <PropertyStopSalesRow
                                    key={stopSale.id}
                                    item={stopSale}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </Card>
        </section>
    );
};

export default PropertyStopSalesList;
